export const formTsAgreementConfirmFields = {
  CONFIRM: 'confirm',
};
